import {ColumnSkeleton} from '../ColumnSkeleton'

export function CategoriesSkeleton() {
  return (
    <>
      {Array(7)
        .fill({})
        .map((_, idx) => (
          <div
            key={idx}
            className="flex items-center relative border-b-0.5 border-gray-700 py-3 mx-4"
          >
            <span className="w-5 h-5 rounded-full bg-gray-700 mr-2" />
            <ColumnSkeleton width={150} />
            <ColumnSkeleton width={15} classes="mr-2 absolute right-2" />
          </div>
        ))}
    </>
  )
}
